<template>
    <div class="ps-container" ref="ps" :is="tagname">
        <slot />
    </div>
</template>

<script>
export default {
    name: "vue-ps",
    props: {
        tagname: {
            type: String,
            default: "div",
        },
    },
    methods: {
        scrollTo({ el, speed = 1000 }) {
            $(this.$refs.ps).animate(
                {
                    scrollTop: $(el).offset().top,
                },
                speed
            );
        },
    },
};
</script>

<style lang="scss">
.ps-container {
    position: relative;
    overflow: auto;
}
</style>
